 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		31: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		31: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"WArticleListingFeaturedArticles~WNonFeaturedArticles","2":"WAccordion","3":"WArticleBodyImage","4":"WArticleBodyNews","5":"WArticleHeader","6":"WArticleListingFeaturedArticles","7":"WArticleListingPageHeader","8":"WArticleTaxonomies","9":"WAuthor","10":"WBreadcrumb","11":"WBrightcove","12":"WDataLayerScript","13":"WEmbedGallery","14":"WFacts","15":"WHeroImage","16":"WIntroParagraph","17":"WJumpLinks","18":"WLatestNews","19":"WMoreOnThis","20":"WMultiPageGuides","21":"WNonFeaturedArticles","22":"WSharingOptionsHorizontal","23":"WSharingOptionsVertical","24":"WSubVerticalHeader","25":"WSubVerticalJumpLinks","26":"WSuperCategorySection","27":"affiliateDisclaimer","28":"conversionBanner","30":"relatedArticleLinks","32":"verticalAdviceCards","33":"verticalArticleCards","34":"verticalLatestNews","35":"verticalSubVerticalLinks"}[chunkId]||chunkId) + "." + {"1":"e71e77b513e4dea9a322","2":"522650f64bb9ea7f04b0","3":"0fbb9f515f73e3ba7c91","4":"c7e4224c6f6ad7803476","5":"d69d02af314d0a2ba4dd","6":"0b1fe6ae2ed373dc86c9","7":"9b1cf72579e785a5bb3d","8":"bc0f0d099a7c7ec2d306","9":"1579c5b34ce08e88b117","10":"15bab818f1db1abda680","11":"5eda192e1ee258cad357","12":"f0833a7bfc54a130d5fc","13":"755e2c11c01891a5655e","14":"fecac9b71d3fc4db3779","15":"49467394d24035e1c22a","16":"58228fde1ea0d6448af5","17":"66cb99f05ba6577bfad0","18":"452b9034be759d1cf295","19":"294db014f1c55580c5f4","20":"ea00ce5920ef54fb31fa","21":"59124cbbd4fd9ac79a23","22":"295e7ad6e6af8d5cd74b","23":"112e7706fc9cdaa50b24","24":"4bf9b9154f5443388087","25":"5b70e9f877c4d4142bb9","26":"31caf7a6be8a32d6a13f","27":"c8ad46b6c5b63cd259ab","28":"6711ec214b6bf74f4c07","30":"4f68bc100321668909f9","32":"b3157deb5b71a9ac9684","33":"12c45f910efd5a2f3564","34":"049c491c943c45e6e1a9","35":"4362cf5d69746713edca"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"11":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"30":1,"32":1,"35":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"1":"WArticleListingFeaturedArticles~WNonFeaturedArticles","2":"WAccordion","3":"WArticleBodyImage","4":"WArticleBodyNews","5":"WArticleHeader","6":"WArticleListingFeaturedArticles","7":"WArticleListingPageHeader","8":"WArticleTaxonomies","9":"WAuthor","10":"WBreadcrumb","11":"WBrightcove","12":"WDataLayerScript","13":"WEmbedGallery","14":"WFacts","15":"WHeroImage","16":"WIntroParagraph","17":"WJumpLinks","18":"WLatestNews","19":"WMoreOnThis","20":"WMultiPageGuides","21":"WNonFeaturedArticles","22":"WSharingOptionsHorizontal","23":"WSharingOptionsVertical","24":"WSubVerticalHeader","25":"WSubVerticalJumpLinks","26":"WSuperCategorySection","27":"affiliateDisclaimer","28":"conversionBanner","30":"relatedArticleLinks","32":"verticalAdviceCards","33":"verticalArticleCards","34":"verticalLatestNews","35":"verticalSubVerticalLinks"}[chunkId]||chunkId) + "." + {"1":"89ed765d74a2d70efba2","2":"1e84ac93f615e686b156","3":"4737212b50322616f238","4":"962b8329cbc6fd94aeba","5":"4caf0813a51b9ab35546","6":"385ed3f614c7261f5ad5","7":"4913c39f9f4372f7feda","8":"e3309d5163a20df8995b","9":"8cb67623cd7d213877e0","10":"31d6cfe0d16ae931b73c","11":"5cfa08e787f325232795","12":"31d6cfe0d16ae931b73c","13":"0b22e1148272a54551ca","14":"a880793dd51dfdf69eeb","15":"6c78c85c1e03b167966e","16":"d5e7c10727a564bbf5c7","17":"f4479593f669e54cd4c3","18":"dc97f5f52dbed2dc415d","19":"8b8678848f8d5557b4fe","20":"f8c09ceac62af8ee9e12","21":"398a67ccb22683fb3c11","22":"839700b78611bca2fbfe","23":"ef7e310e800091c0f170","24":"701b1a38d4cde63ca200","25":"4b7b2e710e096e0df68d","26":"68397858b99278d68890","27":"7d0b8b782d6902f3080d","28":"fa833803bb1a7284f5df","30":"2f6f2878809890bf12c8","32":"847c5ab90471c62265c8","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"927c535606d3ca44858e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/client/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
